import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/han.webp',
  './images/han1.webp',
  './images/han2.webp',
  './images/han3.webp',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

  const content = {
    en: `Hangzhou, the capital of Zhejiang Province, is one of China’s most beautiful cities, famous for its classical scenery, ancient culture, and the legendary West Lake.

Top places to visit:

• West Lake – A UNESCO World Heritage Site surrounded by pagodas, gardens, and walking paths.
• Leifeng Pagoda – A historic tower offering views over West Lake and a story from Chinese legend.
• Lingyin Temple – One of China’s largest and wealthiest Buddhist temples, nestled in forested hills.
• Longjing Tea Plantations – Visit the origin of China’s famous Dragon Well green tea.
• Qinghefang Ancient Street – A preserved street full of traditional shops, tea houses, and snacks.
• Xixi National Wetland Park – A peaceful area with canals, birds, and old waterways.
• China National Silk Museum – A fascinating place to learn about the history of silk in China.
• Song Dynasty Town – A cultural theme park with live performances and ancient-style architecture.
• Grand Canal Hangzhou – The southern tip of the world’s longest manmade canal.
• Broken Bridge – A romantic spot with views of the lake and snow in winter.

Hangzhou is also a food haven, known for delicacies like Dongpo pork, Beggar’s chicken, and West Lake vinegar fish.`,

    zh: `杭州是浙江省省会，被誉为“中国最美城市”之一，以西湖美景、古代文化和悠久历史而闻名。

推荐景点：

• 西湖 – 联合国教科文组织世界遗产，环湖有亭台楼阁、花园和步道。
• 雷峰塔 – 坐落于西湖南岸的历史古塔，与“白蛇传”传说相关。
• 灵隐寺 – 中国著名佛教寺院之一，藏于青山绿水之间，香火鼎盛。
• 龙井茶园 – 参观中国著名龙井绿茶的产地，体验采茶与品茗。
• 清河坊街 – 保留古风的街道，有传统手工艺、茶馆和杭州特色小吃。
• 西溪湿地公园 – 城市中的天然湿地，水网密布、生态丰富。
• 中国丝绸博物馆 – 了解中国丝绸的悠久历史与精湛工艺。
• 宋城 – 以宋代文化为主题的乐园，有大型演出和古风建筑。
• 京杭大运河杭州段 – 世界最长人工运河的南端，见证千年水路交通。
• 断桥 – 位于西湖白堤尽头，传说中的“断桥残雪”景色浪漫。

杭州美食也令人回味，如东坡肉、叫花鸡、西湖醋鱼等都是当地代表菜肴。`
  };

  return (
    <div className="travel-form-container2">
      {/* Row 1 - Description */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/han.webp" className="travel-image2" />
          <img src="./images/han2.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Hangzhou</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button
              onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#967969',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
      <div className="carousel-container2">
        <div className="carousel-heading-column">
          <h2 className="carousel-heading">Explore Hangzhou</h2>
          <p className="carousel-subheading">
            Sail across poetic waters, sip fresh tea, and step into timeless Chinese charm.
          </p>
        </div>

        <div className="carousel2" ref={carouselRef}>
          {images.map((imgSrc, index) => (
            <img key={index} src={imgSrc} className="carousel-image2" />
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;
